<template>
  <section class="features-section">
    <v-container style="max-width: 1200px">
      <div class="text-center mb-12">
        <p class="section-eyebrow">{{ $t('features.eyebrow') }}</p>
        <h2 class="section-title">{{ $t('features.title') }}</h2>
        <p class="section-subtitle mx-auto mt-4" style="max-width: 540px">
          {{ $t('features.subtitle') }}
        </p>
      </div>

      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          sm="6"
          md="4"
        >
          <div class="feature-card">
            <div class="feature-icon-wrap" :style="{ background: feature.iconBg }" >
              <v-icon color="primary" size="26">{{ feature.icon }}</v-icon>
            </div>
            <h3 class="feature-title mt-5 mb-3">{{ feature.title }}</h3>
            <p class="feature-desc">{{ feature.desc }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
const META = [
  { icon: 'mdi-cards-outline',          iconColor: '#9ca3af', iconBg: '#EEF0FB' },
  { icon: 'mdi-clipboard-text-outline', iconColor: '#9ca3af', iconBg: '#EEF0FB' },
  { icon: 'mdi-robot-outline',          iconColor: '#9ca3af', iconBg: '#EEF0FB' },
  { icon: 'mdi-chart-line',             iconColor: '#9ca3af', iconBg: '#EEF0FB' },
  { icon: 'mdi-account-group-outline',  iconColor: '#9ca3af', iconBg: '#EEF0FB' },
  { icon: 'mdi-cellphone',              iconColor: '#9ca3af', iconBg: '#EEF0FB' },
]

export default {
  name: 'FeaturesGrid',
  computed: {
    features() {
      const items = this.$t('features.items')
      return META.map((m, i) => ({ ...m, ...items[i] }))
    },
  },
}
</script>

<style scoped>
.features-section {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0px;
  padding-bottom: 96px;
  background: #ffffff;
}

.section-eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  color: #F77317;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
}

.section-title {
  font-size: 2.4rem;
  font-weight: 900;
  color: #4055AF;
  letter-spacing: -1px;
  line-height: 1.15;
}

@media (max-width: 600px) {
  .section-title { font-size: 1.9rem; }
}

.section-subtitle {
  font-size: 1.05rem;
  color: #666;
  line-height: 1.75;
}

.feature-card {
  padding: 32px 28px;
  border: 1px solid #ebebeb;
  border-radius: 20px;
  height: 100%;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  background: white;
  cursor: default;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 40px rgba(66, 87, 178, 0.1);
  border-color: #d0d5f0;
}

.feature-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #4055AF;
  letter-spacing: -0.3px;
}

.feature-desc {
  font-size: 0.9rem;
  color: #777;
  line-height: 1.7;
  margin: 0;
}
</style>
